import { render, staticRenderFns } from "./frequent_items_list_item.vue?vue&type=template&id=35483de0&"
import script from "./frequent_items_list_item.vue?vue&type=script&lang=js&"
export * from "./frequent_items_list_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports